import { PiUsersThreeLight, PiDeskLight, PiCoatHangerLight, PiCalculatorLight, PiChatsCircle, PiCubeLight, PiChartBarLight } from "react-icons/pi";
import { IoSettingsOutline, IoPricetagsOutline } from "react-icons/io5";
import { AiOutlineEuro } from "react-icons/ai";
import { BiEuro } from "react-icons/bi";
// import { PiToolLight } from "react-icons/pi"; 
import { LiaEuroSignSolid } from "react-icons/lia";
import { HiOutlineArchiveBoxXMark } from "react-icons/hi2";
import { RiFileTextLine } from "react-icons/ri";
// Icono nuevo para dotaciones

export const cardData = [
    {
        id: 1,
        icon: <PiUsersThreeLight />,
        title: "Gestión de usuarios/empresas",
        link: "usuarios"
    },
    {
        id: 2,
        icon: <PiDeskLight />,
        title: "Gestión de muebles",
        link: "muebles"
    },
    {
        id: 3,
        icon: <PiCoatHangerLight  />, 
        title: "Maestro de Dotaciones",
        link: "maestro-dotaciones" 
    },
    {
        id: 4,
        icon: <LiaEuroSignSolid />, 
        title: "Gestión de Moneda",
        link: "gestion-moneda" 
    },
    {
        id: 5,
        icon: <PiCalculatorLight />, 
        title: "Gestión de Tarifas",
        link: "gestion-tarifas" 
    },
    {
        id: 6,
        icon: <IoPricetagsOutline />, 
        title: "Solicitudes tarifas",
        link: "solicitudes-tarifas" 
    },
    {
        id: 7,
        icon: <HiOutlineArchiveBoxXMark  />, 
        title: "Muebles descatalogados",
        link: "muebles-descatalogados" 
    },
    {
        id: 8,
        icon: <AiOutlineEuro />,
        title: "Presupuestos",
        link: "presupuestos"
    }
    // {
    //     id: 9,
    //     icon: <PiCubeLight />,
    //     title: "Presupuestos BIM 5D",
    //     link: "presupuestos-bim-5d"
    // },
    // {
    //     id: 10,
    //     icon: <PiChartBarLight />,
    //     title: "Ratios",
    //     link: "ratios"
    // },
    // {
    //     id: 11,
    //     icon: <RiFileTextLine />,
    //     title: "Presupuestos MC",
    //     link: "presupuestos-mc"
    // } 
];
